// FlagBanners.tsx — renders SimulationResult.flags + backtest meta.rangeClamped as
// prominent banners above the results. This is where the "feature honesty rule" from
// PLAN.md becomes visible UI: disabled features and documented approximations are
// never silently hidden.
import type { Flags } from '@etf-cockpit/engine';
import { Banner } from './Banner.js';
import { formatDateDe } from '../lib/format.js';
import type { BacktestMeta } from '../lib/types.js';

export interface FlagBannersProps {
  flags: Flags | undefined;
  rangeClamped: BacktestMeta['rangeClamped'] | undefined;
}

export function FlagBanners({ flags, rangeClamped }: FlagBannersProps) {
  if (!flags && !rangeClamped) return null;
  return (
    <div>
      {flags?.ageDataMissing ? (
        <Banner variant="warning" title="AGE-Backtest deaktiviert">
          <span>{flags.ageDataMissing.reason}</span>
        </Banner>
      ) : null}
      {flags?.basisCorrectionApproximate ? (
        <Banner variant="neutral" title="Anschaffungskosten-Korrektur angenähert">
          <span>
            Für mindestens eine Meldung fehlte der amtliche OeKB-Korrekturbetrag; die
            Anschaffungskosten wurden stattdessen um den AGE-Bruttobetrag erhöht
            (dokumentierte Annäherung, keine erfundenen Daten).
          </span>
        </Banner>
      ) : null}
      {flags?.distributionTaxApproximate ? (
        <Banner variant="neutral" title="Ausschüttungssteuer angenähert">
          <span>
            Für mindestens eine Ausschüttung fehlte der amtliche steuerpflichtige
            OeKB-Betrag; die KESt wurde stattdessen vom vollen Bruttobetrag berechnet
            (dokumentierte Annäherung, keine erfundenen Daten).
          </span>
        </Banner>
      ) : null}
      {rangeClamped ? (
        <Banner variant="info" title="Zeitraum angepasst">
          <span>
            Angefragt {formatDateDe(rangeClamped.requestedFrom)}–{formatDateDe(rangeClamped.requestedTo)},
            verwendet wurde der verfügbare Datenbereich (siehe Daten-Tab für die genaue
            Abdeckung).
          </span>
        </Banner>
      ) : null}
    </div>
  );
}
